export default {
    namespaced: true,
    state: {
        usersNotRead: 0,
        organizersNotRead: 0,
    },
    mutations: {
        setNotRead: function (state, data) {
            state.usersNotRead = data.user_count;
            state.organizersNotRead = data.organizer_count;
        },
    },
    actions: {
        fetchNotReadMessagesCount: ({commit}) => {
            return axios.get(`/messages/notReadMessagesCount`)
                .then(res => {
                    commit('setNotRead', res.data.data)
                })
                .catch(err => {
                    console.error(err);
                })
        },
        markAsRead: ({dispatch}, id) => {
            return axios.put(`/messages/${id}/markAsRead`)
                .then(() => {
                    dispatch("fetchNotReadMessagesCount")
                })
        },
    }
};
